
const firstHeader =['车型','科目','序号','科目名称','期初数','合计',  ]


const carTypeIndex = ['1','1.1','1.2','1.3','2','3','4','5','6','7 ','8',]

const leftHeader = [
    {
        name:'订单计划',
        ht:1
    },
    {
        name:'◆在产',
        ht:2
    },
    {
        name:'◆在途',
        ht:2
    },
    {
        name:'◆到港',
        ht:2
    },
    {
        name:'销售计划',
        ht:1
    },
    {
        name:'终端库存',
        ht:1
    },
    {
        name:'销售收入',
        ht:1
    },
    {
        name:'销售利润',
        ht:1
    },
    {
        name:'销售利润率',
        ht:1
    },
    {
        name:'现金流量表',
        ht:1
    },
    {
        name:'现金流入小计',
        ht:2
    },
    {
        name:'现金流出小计',
        ht:2
    },
    {
        name:'当期净现金流量',
        ht:1
    },{
        name:'累计净现金流量',
        ht:1
    },{
        name:'付款计划',
        ht:1
    },
    // {
    //     name:'自有资金',
    //     ht:2
    // },{
    //     name:'信保资金',
    //     ht:2
    // },{
    //     name:'第3方资金',
    //     ht:2
    // },

]
const carTypeItem = [
    {
        name:'订单计划',
        ht:1
    },{
        name:'◆在产',
        ht:2
    },{
        name:'◆在途',
        ht:2
    },{
        name:'◆到港',
        ht:2
    },{
        name:'◆在途合计',
        ht:2
    },{
        name:'销售计划',
        ht:1
    },{
        name:'终端库存',
        ht:1
    },{
        name:'付款类型',
        ht:1
    },{
        name:'销售收入',
        ht:1
    },{
        name:'销售利润',
        ht:1
    },{
        name:'销售利润率',
        ht:1
    },
]
const border = []

export { firstHeader, border,carTypeItem,carTypeIndex}